//VzmAlert.js
// Copyright to Lab is Fun, Inc. All rights reserved. 2024.
import {
    Button,
    Dialog, DialogActions, DialogContent, DialogTitle,
    List, ListItem, ListItemIcon, ListItemText
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import InfoIcon from '@mui/icons-material/Info';
import CheckIcon from '@mui/icons-material/Check';
import { AppStyle, UILabel, ApiMsg } from '../value/AppConst';

const titleAlert = 'vzm_title_alert_dialog';

function filterMessages(list) {
    if(list.length > 0) {
        if(list[0]===ApiMsg.AUTH_ERROR) {
            return[
                '인증 오류가 발생했습니다.',
                '활동이 오랫동안 없어서 로그아웃 되었을 수 있습니다.',
                '다시 로그인 해 주세요.'
            ];
        }
    }
    return list;
}

export default function VzmAlert({
    open,
    alertInfo,
    onClose,
}) {

    if(!open) return null;

    const list = typeof alertInfo.message === 'string' ? [alertInfo.message] : alertInfo.message;
    const messages = filterMessages( list );
    // if(list[0] === ApiMsg.AUTH_ERROR) onSessionDisconnect();

    return (
        <Dialog
          open={open}
          onClose={(e)=>onClose()}
          aria-labelledby={titleAlert}
          aria-describedby="alert-dialog-description"
          maxWidth="lg"
        >
            <DialogTitle id={titleAlert} style={{
                fontSize:'1.2rem', fontWeight:'bold', display:'flex', alignItems:'center',
                color: 'white',
                backgroundColor: alertInfo.isError ? AppStyle.ErrorRGB : AppStyle.PrimaryRGB
                }}
            >
                {
                    alertInfo.isError ?
                    <ErrorOutlineIcon /> :
                    <InfoIcon />
                } &nbsp;
                {alertInfo.title}
            </DialogTitle>
            <DialogContent style={{minWidth:240, fontSize:'1.1rem'}}>
                <List dense={true} style={{marginTop:10}}>
                {
                    messages.length > 0 ?
                    messages
                    .filter((t)=>{
                        return t && t.length > 0;
                    })
                    .map((text, index) => {
                    return(
                        <ListItem key={index}>
                        <ListItemIcon><CheckIcon style={{fontSize:'12pt'}} /></ListItemIcon>
                        <ListItemText primary={text} />
                        </ListItem>
                    );
                    })
                    : <ListItem>{alertInfo.title}</ListItem>
                }
                </List>
            </DialogContent>
            <DialogActions>
                <Button
                color={AppStyle.mui.primary} variant={AppStyle.mui.contained}
                onClick={(e)=>onClose()}
                >
                {UILabel.buttonOk}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
